module.exports = __webpack_public_path__ + "media/images/loading-f657825a.gif";